import { axios_instance } from "@/api/api";
import { router } from "@/router/router";
import { defineStore } from "pinia";
import { computed, onMounted, ref, watch } from "vue";
import { toast } from "vue3-toastify";

export interface CampaignDetail {
  id: string;
  name: string;
  description?: string;
  created_at: number;
  updated_at: number;
}

export const use_campaign_detail = defineStore("campaign_detail", () => {
  const id = computed(() =>
    String(router.currentRoute.value.params.campaign_id),
  );
  const loading = ref<boolean>(false);

  const campaign_detail = ref<CampaignDetail>();

  const tabs: {
    value: string;
    route_name: string;
    ico: string;
  }[] = [
    {
      value: "Tổng quan",
      route_name: "CampaignDashboard",
      ico: "fa-solid fa-gauge-high",
    },
    {
      value: "Máy trạm",
      route_name: "CampaignClients",
      ico: "fa-solid fa-desktop",
    },
    {
      value: "Cập nhật",
      route_name: "CampaignUpdate",
      ico: "fa-solid fa-arrow-up",
    },
    {
      value: "Bộ cài đặt",
      route_name: "CampaignInstallers",
      ico: "fa-solid fa-wrench",
    },
    {
      value: "Báo cáo",
      route_name: "CampaignReport",
      ico: "fa-solid fa-chart-line",
    },
    {
      value: "Thành viên",
      route_name: "CampaignMembers",
      ico: "fa-solid fa-users",
    },
  ];

  function isValidUUID(uuidString: string | undefined): boolean {
    return uuidString !== undefined && uuidString !== "undefined";
  }

  onMounted(() => get_campaign_detail());
  const get_campaign_detail = async () => {
    if (!isValidUUID(id.value)) return;
    loading.value = true;
    try {
      const response = await axios_instance.get<{ data: CampaignDetail }>(
        `/api/v1/view/campaign/${id.value}`,
      );
      campaign_detail.value = response.data.data;
    } catch (err) {
      toast.error(err);
    } finally {
      loading.value = false;
    }
  };
  watch(
    () => [id.value],
    () => get_campaign_detail(),
  );

  return {
    id,
    tabs,
    campaign_detail,
    loading,
  };
});
